import { render, staticRenderFns } from "./RestrictionsManagement.vue?vue&type=template&id=8c3056bc&scoped=true"
import script from "./RestrictionsManagement.vue?vue&type=script&lang=js"
export * from "./RestrictionsManagement.vue?vue&type=script&lang=js"
import style0 from "./RestrictionsManagement.vue?vue&type=style&index=0&id=8c3056bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3056bc",
  null
  
)

export default component.exports